import React, { useEffect } from 'react';
import { Outlet, useLocation, useMatch } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileActionBar } from './MobileActionBar';
import { SITE } from '../../data/site';
const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: SITE.name,
  alternateName: SITE.shortName,
  url: SITE.url,
  logo: SITE.logo,
  telephone: '+1-702-375-5900',
  description: 'Las Vegas CCW class, Nevada CCW renewal, concealed carry class Las Vegas and women’s firearms training Las Vegas. Sheriff-approved since 2010.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: `${SITE.location.street}, Conservation Room (2nd floor), Bass Pro Shops`,
    addressLocality: SITE.location.city,
    addressRegion: SITE.location.region,
    postalCode: SITE.location.postal,
    addressCountry: 'US'
  },
  openingHoursSpecification: [{
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '08:00',
    closes: '18:00'
  }],
  sameAs: [SITE.social.ccwMaggie, SITE.social.womensDefenseNetwork]
};
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  const onCourseDetail = useMatch('/courses/:slug');
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        window.setTimeout(() => el.scrollIntoView({
          block: 'start'
        }), 50);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="min-h-screen w-full bg-white" data-id="element-382" data-mp="3w3kx14tk01kf">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2 focus:text-navy" data-id="element-383" data-mp="3r1dhy6dfg5dv">
        Skip to content
      </a>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(localBusinessSchema)
    }} data-id="element-384" data-mp="2fm6zt00wiswl" />
      <TopBar data-id="element-385" data-mp="17p45nrafcxcs" />
      <Header data-id="element-386" data-mp="17oknqakry8yr" />
      <main id="main" data-id="element-387" data-mp="17lyjokx3ebla">
        <Outlet data-id="element-388" data-mp="1bp4pjrgam0r8" />
      </main>
      <Footer data-id="element-389" data-mp="1bocymtxn4r7a" />
      {!onCourseDetail && <MobileActionBar data-id="element-390" data-mp="1bnaa2snsj0uj" />}
    </div>;
}